/**
 * KPI summary cards — clickable metrics that filter the visible dataset.
 */
import React from 'react';

export default function KPISummaryCards({
  overdueCount,
  dueSoonCount,
  awaitingAssignmentCount,
  inProgressCount,
  completedThisMonthCount,
  activeKPI,
  onKPIClick,
  isCompliance,
}) {
  const cards = [
    {
      id: 'overdue',
      label: 'Overdue',
      count: overdueCount,
      color: 'bg-red-50 border-red-200/80 hover:bg-red-100/80 text-red-800',
      activeColor: 'ring-2 ring-red-400 bg-red-50',
    },
    {
      id: 'due_soon',
      label: 'Due in 7 Days',
      count: dueSoonCount,
      color: 'bg-amber-50 border-amber-200/80 hover:bg-amber-100/80 text-amber-800',
      activeColor: 'ring-2 ring-amber-400 bg-amber-50',
    },
    ...(isCompliance
      ? [
          {
            id: 'awaiting',
            label: 'Awaiting Assignment',
            count: awaitingAssignmentCount,
            color: 'bg-slate-50 border-slate-200/80 hover:bg-slate-100/80 text-slate-700',
            activeColor: 'ring-2 ring-slate-400 bg-slate-100',
          },
        ]
      : []),
    {
      id: 'in_progress',
      label: 'In Progress',
      count: inProgressCount,
      color: 'bg-sky-50 border-sky-200/80 hover:bg-sky-100/80 text-sky-800',
      activeColor: 'ring-2 ring-sky-400 bg-sky-50',
    },
    {
      id: 'completed',
      label: 'Completed This Month',
      count: completedThisMonthCount,
      color: 'bg-slate-50 border-slate-200/80 hover:bg-slate-100/80 text-slate-600',
      activeColor: 'ring-2 ring-slate-400 bg-slate-100',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
      {cards.map((card) => (
        <button
          key={card.id}
          type="button"
          onClick={() => onKPIClick(card.id)}
          className={`flex flex-col items-start p-4 rounded-xl border text-left transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500/40 ${
            activeKPI === card.id ? card.activeColor : card.color
          }`}
        >
          <span className="text-2xl font-bold tabular-nums">{card.count}</span>
          <span className="text-xs font-medium mt-0.5 opacity-90">{card.label}</span>
        </button>
      ))}
    </div>
  );
}
